import styled from 'styled-components';

export const StyledGroupBtn = styled.div`
  display: flex;
  gap: 0.5rem;
`;
